<div class="dialog-header">
    <span>Export Situation Report Data </span>
    <button mat-icon-button [mat-dialog-close]="false">
        <vulcan-icon icon="x"></vulcan-icon>
    </button>
</div>

<div class="dialog-content">
    <p class="instruction-text">Select the data sections you would like to export</p>

    @for(option of widgetOptions; track option.displayName) {
    <div>
        <mat-checkbox [(ngModel)]="option.selected">{{ option.displayName }}</mat-checkbox>
    </div>
    }
</div>

<div class="dialog-actions">
    <button mat-flat-button color="primary" (click)="downloadZip()">Export</button>
</div>
